import { currencyFormatter } from "../../core/function/function-generic";

interface Props {
    amount: number;
    currencyFrom:string;
    currencyTo:string;
}

export const Currency = ({amount, currencyFrom, currencyTo}: Props) => {
    return (
        <>
            <div>
                <p className='text-justify text-[#000] font-[Montserrat] leading-[27px] not-italic text-[16px] font-semibold'>
                    {currencyFormatter({
                        currency: "USD",
                        value:amount
                    })}
                </p>
                <span className="text-13-500">{currencyFrom} to {currencyTo} </span>
            </div>
        </>

    )
}